import getters from './getters';
import mutations from './mutations';
import actions from './actions';
function initState() {
    return {
        result: null,
        waiting: false,
        pageIndex: 0
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
